var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataGetter',{attrs:{"url":_vm.url,"params":{
    Country: _vm.countries,
    CODE_INDICATOR: _vm.indicator,
    CODE_SECTOR: _vm.sector,
    CODE_PRODUCT: _vm.product || _vm.selectedProduct,
    CODE_UNIT: _vm.unit,
  },"initialData":[],"formatter":_vm.monthly ? _vm.mapMonthly : null,"lazy":""},on:{"fetched":_vm.setUnits},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('DataSlicer',{attrs:{"data":data,"yAxisDimension":"Country","xAxisDimension":"CODE_YEAR","valueDimension":"Value","no-single-value":"","no-x-numeric":!!_vm.monthly},scopedSlots:_vm._u([{key:"default",fn:function({ slicedData, xAxisCategories }){return [_c('Chart',{attrs:{"title":`${
        _vm.monthly
          ? `Monthly ${_vm.topicName} prices`
          : `${_vm.topicName} energy prices over time`
      }, ${_vm.baseCountry}`,"chartType":_vm.monthly || _vm.compareCountries.length > 0 ? 'line' : 'column',"series":slicedData
          .map((series) => ({
            ...series,
            colorIndex: _vm.countries.indexOf(series.name),
          }))
          .sort((a, b) => a.colorIndex - b.colorIndex),"units":_vm.units,"chartOptions":{
        chart: {
          height: 300,
        },
        plotOptions: {
          column: {
            stacking: undefined,
          },
          line: {
            marker: {
              enabled: !_vm.monthly,
            },
            label: {
              enabled: true,
            },
          },
        },
        yAxis: {
          min: 0,
        },
        xAxis: {
          type: _vm.monthly ? 'datetime' : 'number',
          tickPositions: _vm.monthly
            ? null
            : xAxisCategories.length < 10
            ? xAxisCategories.map((year) => parseInt(year))
            : xAxisCategories.reduce(
                (ticks, year, i) =>
                  i === 0 ||
                  i === xAxisCategories.length - 1 ||
                  year % (_vm.half ? 5 : 2) === 0
                    ? [...ticks, parseInt(year)]
                    : ticks,
                []
              ),
        },
      },"half":""}},[_c('ControlGroup',[(!_vm.product)?_c('DataGetter',{attrs:{"url":`${_vm.url}/list/CODE_PRODUCT`,"params":{
            Country: _vm.baseCountry,
            CODE_INDICATOR: _vm.indicator,
            CODE_SECTOR: _vm.sector,
            CODE_UNIT: _vm.unit,
          },"lazy":"","child-element-type":null},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [(data)?_c('Dropdown',{attrs:{"label":"Show product","options":data,"reset-on-invalid":"","fixed":""},model:{value:(_vm.selectedProduct),callback:function ($$v) {_vm.selectedProduct=$$v},expression:"selectedProduct"}}):_vm._e()]}}],null,true)}):_vm._e(),_c('DataGetter',{attrs:{"url":`${_vm.url}/list/Country`,"params":{
            CODE_PRODUCT: _vm.product || _vm.selectedProduct,
            CODE_INDICATOR: _vm.indicator,
            CODE_SECTOR: _vm.sector,
            CODE_UNIT: _vm.unit,
          },"lazy":"","child-element-type":null},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [(data)?_c('Multiselect',{attrs:{"label":"Compare countries","options":data,"maxItems":5,"reset-on-invalid":"","fixed":""},model:{value:(_vm.compareCountries),callback:function ($$v) {_vm.compareCountries=$$v},expression:"compareCountries"}}):_vm._e()]}}],null,true)})],1)],1)]}}],null,true)})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }